import React  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { Fragment } from "react";

export default function Extracurricular() {
    
    let app = ApplicantContainer.useContainer();

    let inputExtracurricularCompete = app.inStdValues.frExtracurricularCompete;
    let inputExtracurricularLeadership = app.inStdValues.frExtracurricularLeadership;
    let inputExtracurricularOther = app.inStdValues.frExtracurricularOther;
    let inputExtracurricularAward = app.inStdValues.frExtracurricularAward;
    
      const addExtracurricularCompete = index => {    

        const values = [...inputExtracurricularCompete];
        if(values.length < 5){
            values.splice(index+1, 0, {  CompeteYear: '', CompeteName: '', CompeteResult: '' });
        }

        app.onChangeInStdValues({...app.inStdValues, frExtracurricularCompete:values}); 
      }

      const delExtracurricularCompete = index => {    

        if(inputExtracurricularCompete.length === 1) return 0;

        const values = [...inputExtracurricularCompete];    
        values.splice(index, 1);
        
        app.onChangeInStdValues({...app.inStdValues, frExtracurricularCompete:values}); 
      }

      const handleInputChangeCompete = (inputname, index, evt) => {        

        if(evt.target.name === 'frExtracurricularCompeteYear') 
        evt.target.value = evt.target.value.replace(/[^0-9/]/g,'');

        const values = [...inputExtracurricularCompete];  
        
        values[index].[inputname] = evt.target.value;    
        app.onChangeInStdValues({...app.inStdValues, frExtracurricularCompete:values}); 
      };

      const addExtracurricularLeadership = index => {    

        const values = [...inputExtracurricularLeadership];
        if(values.length < 10){
            values.splice(index+1, 0, {  LeaderYear: '', LeaderName: '', LeaderPosition: '' });
        }

        app.onChangeInStdValues({...app.inStdValues, frExtracurricularLeadership:values});
      }

      const delExtracurricularLeadership = index => {    

        if(inputExtracurricularLeadership.length === 1) return 0;

        const values = [...inputExtracurricularLeadership];    
        values.splice(index, 1);

        app.onChangeInStdValues({...app.inStdValues, frExtracurricularLeadership:values}); 
      }

      const handleInputChangeLeadership = (inputname, index, evt) => {        

        if(evt.target.name === 'frExtracurricularLeadershipYear') 
        evt.target.value = evt.target.value.replace(/[^0-9/]/g,'');


        const values = [...inputExtracurricularLeadership];  
        
        values[index].[inputname] = evt.target.value;    
        app.onChangeInStdValues({...app.inStdValues, frExtracurricularLeadership:values});
      };

      const addExtracurricularAward = index => {    

        const values = [...inputExtracurricularAward];
        if(values.length < 5){
            values.splice(index+1, 0, {  AwardYear: '', AwardName: '' });
        }

        app.onChangeInStdValues({...app.inStdValues, frExtracurricularAward:values});
      }

      const delExtracurricularAward = index => {    

        if(inputExtracurricularAward.length === 1) return 0;

        const values = [...inputExtracurricularAward];    
        values.splice(index, 1);


        app.onChangeInStdValues({...app.inStdValues, frExtracurricularAward:values});
      }

      const handleInputChangeAward = (inputname, index, evt) => {     
          
        if(evt.target.name === 'frExtracurricularAwardYear') 
        evt.target.value = evt.target.value.replace(/[^0-9/]/g,'');


        const values = [...inputExtracurricularAward];  
        
        values[index].[inputname] = evt.target.value;    
        app.onChangeInStdValues({...app.inStdValues, frExtracurricularAward:values});
      };


      const addExtracurricularOther = index => {    

        const values = [...inputExtracurricularOther];
        values.splice(index+1, 0, {  AwardYear: '', AwardName: '' });

        app.onChangeInStdValues({...app.inStdValues, frExtracurricularOther:values});
      }

      const delExtracurricularOther = index => {    

        if(inputExtracurricularOther.length === 1) return 0;

        const values = [...inputExtracurricularOther];    
        values.splice(index, 1);

        app.onChangeInStdValues({...app.inStdValues, frExtracurricularOther:values});
      }

      const handleInputChangeOther = (inputname, index, evt) => {       
          
        if(evt.target.name === 'frExtracurricularOtherYear') 
        evt.target.value = evt.target.value.replace(/[^0-9/]/g,'');


        const values = [...inputExtracurricularOther];  
        
        values[index].[inputname] = evt.target.value;    
        app.onChangeInStdValues({...app.inStdValues, frExtracurricularOther:values});
      };


    return (
        
    app.showExtracurricular ? 
    <>
    
    <Form.Row>
        <Col xs={12}>
            {app.inStdValues.frScholarship === 'JCF' || app.inStdValues.frScholarship === 'COMMUNITY' ?
            <Form.Group as={Col} >
            <Form.Label>1. Involvement in Clubs & Societies</Form.Label>                
            </Form.Group>
            :
            <Form.Group as={Col} >
            <Form.Label>1. Involvement in Leadership Bodies/ Clubs & Societies (with leadership position, i.e: President/ Vice President/ Leader/ EXCO)</Form.Label>                
            </Form.Group>
            }
        </Col>
        {app.inStdValues.frScholarship === 'JCF' || app.inStdValues.frScholarship === 'COMMUNITY' ?
        <div className='cc_clause'>
            Kindly list your top 10 leadership positions or roles.
        </div>
        :
         <div className='cc_clause'>
            Kindly list your top 10 leadership positions or roles. Any additional involvement can be included in your CV.
        </div>
        }
    </Form.Row>
    <Form.Row>
        <Col xs={12}>     
        <Form.Row className="d-none d-md-flex">
            <Col xs={12} md={2} lg={2} className='table-header'>     
            <Form.Group as={Col} >
            <Form.Label>Year of Service</Form.Label>
            </Form.Group>       
            </Col>
            <Col xs={12} md={4} lg={4} className='table-header'>            
            <Form.Group as={Col} >
            <Form.Label>Name of Leadership Bodies/ Clubs & Societies</Form.Label>
            </Form.Group>       
            </Col>
            <Col xs={12} md={4} lg={4} className='table-header'>            
            <Form.Group as={Col} >
            <Form.Label>Position Held</Form.Label>            
            </Form.Group>       
            </Col>                                 
            <Col xs={12} md={2} lg={2} className='table-header d-flex justify-content-center'>          
            <Form.Group as={Col}  className="segbutton">
            <Form.Label>action</Form.Label>            
            </Form.Group>       
        </Col>        
        </Form.Row> 

        {inputExtracurricularLeadership.map((inputField, index) => (      
            <Fragment key={`${inputField}~${index}`}>
            <Form.Row>
                <Col xs={12} md={2} lg={2}>
                <Form.Group as={Col}>            
                    <Form.Label className="d-flex d-md-none">Year of Service</Form.Label>    
                    <Form.Control type="text" name="frExtracurricularLeadershipYear[]" required placeholder="" value={inputField.LeaderYear} onChange={evt => handleInputChangeLeadership('LeaderYear', index, evt)} />                    
                </Form.Group>
                </Col>
                <Col xs={12} md={4} lg={4}>
                <Form.Group as={Col}>                
                <Form.Label className="d-flex d-md-none">Name of Leadership Bodies/ Clubs & Societies</Form.Label>
                    <Form.Control type="text" name="frExtracurricularLeadershipName[]" required placeholder="" value={inputField.LeaderName} onChange={evt => handleInputChangeLeadership('LeaderName', index, evt)} />                    
                </Form.Group>
                </Col>
                <Col xs={12} md={4} lg={4}>
                <Form.Group as={Col}>                
                <Form.Label className="d-flex d-md-none">Position Held</Form.Label>
                    <Form.Control type="text" name="frExtracurricularLeadershipPosition[]" required placeholder="" value={inputField.LeaderPosition} onChange={evt => handleInputChangeLeadership('LeaderPosition', index, evt)} />          
                </Form.Group>
                </Col>        
                <Col xs={12} md={2}  lg={2} className="d-flex justify-content-center">          
                <Form.Group as={Col} className="segbutton">
                    <Form.Label>&nbsp;</Form.Label>
                    <Form.Control type="button" className="add btn btn-outline-primary" value="+" onClick={() => addExtracurricularLeadership(index)} />&nbsp;
                    <Form.Control type="button" className="del btn btn-outline-danger" value="-" onClick={() => delExtracurricularLeadership(index)} />
                </Form.Group>
                </Col>        
            </Form.Row> 
            </Fragment>
        ))}
    </Col>
    </Form.Row>
        
    <Form.Row>
        <Col xs={12}>
            <Form.Group as={Col} >
            <Form.Label>2. Involvement in Competition</Form.Label>
            </Form.Group>
        </Col>
        {app.inStdValues.frScholarship === 'JCF' || app.inStdValues.frScholarship === 'COMMUNITY' ?
        <div className='cc_clause'>
            Kindly list your top 5 competitions.
        </div> 
        :
        <div className='cc_clause'>
            Kindly list your top 5 competitions. Any additional involvement can be included in your CV.
        </div> 
    } 
    </Form.Row>
    <Form.Row>
        <Col xs={12}>
        <Form.Row className="d-none d-md-flex">
            <Col xs={12} md={2} lg={2} className='table-header'>            
            <Form.Group as={Col}>
            <Form.Label>Year of Competition</Form.Label>
            </Form.Group>   
            </Col>
            <Col xs={12} md={4} lg={4} className='table-header'>            
            <Form.Group as={Col}>
            <Form.Label>Name of Competition</Form.Label>
            </Form.Group>   
            </Col>
            <Col xs={12} md={4} lg={4} className='table-header'>            
            <Form.Group as={Col}>
            <Form.Label>Result (winning/ not winning, if winning, what is the winning result)</Form.Label>
            </Form.Group>               
            </Col>                     
            <Col xs={12} md={2} lg={2} className='table-header d-flex justify-content-center'>                      
            <Form.Group as={Col} className="segbutton">
            <Form.Label>action</Form.Label>
            </Form.Group>   
            </Col>        
        </Form.Row> 

        {inputExtracurricularCompete.map((inputField, index) => (      
            <Fragment key={`${inputField}~${index}`}>
            <Form.Row >
                <Col xs={12} md={2} lg={2}>
                <Form.Group as={Col} >    
                    <Form.Label className="d-flex d-md-none">Year of Competition</Form.Label>            
                    <Form.Control type="text" name="frExtracurricularCompeteYear[]" required placeholder="" value={inputField.CompeteYear} onChange={evt => handleInputChangeCompete('CompeteYear', index, evt)} />
                </Form.Group>
                </Col>
                <Col xs={12} md={4} lg={4}>
                <Form.Group as={Col} >                
                    <Form.Label className="d-flex d-md-none">Name of Competition</Form.Label>
                    <Form.Control type="text" name="frExtracurricularCompeteName[]" required placeholder="" value={inputField.CompeteName} onChange={evt => handleInputChangeCompete('CompeteName', index, evt)} />
                </Form.Group>
                </Col>
                <Col xs={12} md={4} lg={4}>
                <Form.Group as={Col} >                
                    <Form.Label className="d-flex d-md-none">Result (winning/ not winning, if winning, what is the winning result)</Form.Label>
                    <Form.Control type="text" name="frExtracurricularCompeteResult[]" required placeholder="" value={inputField.CompeteResult} onChange={evt => handleInputChangeCompete('CompeteResult', index, evt)} />
                </Form.Group>
                </Col>        
                <Col xs={12} md={2}  lg={2} className="d-flex justify-content-center">          
                <Form.Group as={Col} className="segbutton">
                    <Form.Label>&nbsp;</Form.Label>
                    <Form.Control type="button" className="add btn btn-outline-primary" value="+" onClick={() => addExtracurricularCompete(index)} />&nbsp;
                    <Form.Control type="button" className="del btn btn-outline-danger" value="-" onClick={() => delExtracurricularCompete(index)} />
                </Form.Group>
                </Col>        
            </Form.Row> 
            </Fragment>
        ))}
        </Col>
    </Form.Row>     
    <Form.Row>
        <Col xs={12}>
            <Form.Group as={Col} >
            <Form.Label>3. Award Received</Form.Label>
            </Form.Group>
        </Col>
        {app.inStdValues.frScholarship === 'JCF' || app.inStdValues.frScholarship === 'COMMUNITY' ?
        <div className='cc_clause'>
        Kindly list your top 5 Awards.
        </div>
        :
        <div className='cc_clause'>
        Kindly list your top 5 Awards. Any additional involvement can be included in your CV.
        </div>
        }
    </Form.Row>        
    <Form.Row><Col xs={12}>
        <Form.Row className="d-none d-md-flex">
            <Col xs={12} md={5} lg={2} className='table-header'>
            <Form.Group as={Col}>            
            <Form.Label>Year of Award</Form.Label>
            </Form.Group>
            </Col>
            <Col xs={12} md={5} lg={8} className='table-header'>            
            <Form.Group as={Col}>            
            <Form.Label>Name of Award</Form.Label>
            </Form.Group>
            </Col>        
            <Col xs={12} md={2} lg={2} className='table-header d-flex justify-content-center'>
            <Form.Group as={Col} className="segbutton">            
            <Form.Label>action</Form.Label>
            </Form.Group>
            </Col>        
        </Form.Row> 

        {inputExtracurricularAward.map((inputField, index) => (      
            <Fragment key={`${inputField}~${index}`}>
            <Form.Row>
                <Col xs={12} md={5} lg={2}>
                <Form.Group as={Col} >     
                    <Form.Label className="d-flex d-md-none">Year of Award</Form.Label>           
                    <Form.Control type="text" name="frExtracurricularAwardYear[]" required placeholder="" value={inputField.AwardYear} onChange={evt => handleInputChangeAward('AwardYear', index, evt)} />
                </Form.Group>
                </Col>
                <Col xs={12} md={5} lg={8}>
                <Form.Group as={Col} >                
                    <Form.Label className="d-flex d-md-none">Name of Award</Form.Label>
                    <Form.Control type="text" name="frExtracurricularAwardName[]" required placeholder="" value={inputField.AwardName} onChange={evt => handleInputChangeAward('AwardName', index, evt)} />
                </Form.Group>
                </Col>        
                <Col xs={12} md={2}  lg={2} className="d-flex justify-content-center">          
                <Form.Group as={Col} className="segbutton">
                    <Form.Label>&nbsp;</Form.Label>
                    <Form.Control type="button" className="add btn btn-outline-primary" value="+" onClick={() => addExtracurricularAward(index)} />&nbsp;
                    <Form.Control type="button" className="del btn btn-outline-danger" value="-" onClick={() => delExtracurricularAward(index)} />
                </Form.Group>
                </Col>        
            </Form.Row> 
            </Fragment>
        ))}</Col></Form.Row>

        </>
        : <></> 

    );
}